import React from 'react';
import { number, string } from 'prop-types';
import classnames from 'classnames';
import { calculateStarType } from 'components/Star/utils';
import { Star } from 'components';
import './Ratings.scss';

export default function Ratings({ count, stars, className }) {
    const rootClassnames = classnames('ratings', className);

    return count > 0 ? (
        <div className={rootClassnames}>
            {[...Array(5).keys()].map(index => (
                <Star
                    key={index}
                    className="ratings__star"
                    starType={calculateStarType(stars, index)}
                />
            ))}

            <span className="ratings__count">{count}</span>
        </div>
    ) : null;
}

Ratings.propTypes = {
    className: string,
    count: number,
    stars: number,
};

Ratings.defaultProps = {
    className: null,
    count: 0,
    stars: 0,
};
